import eventsApiClient from '../api/client';
const eventsApiUrl = '/event';
const opts = {
    headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
    },
};
const isNotHost = false;
const apiType = 'event';
export const eventsApiPost = async (body, logger) => {
    if (logger) {
        eventsApiClient.setLogger(logger);
    }
    const url = eventsApiUrl;
    return eventsApiClient.post(`${url}/{userId}`, apiType, { data: body, ...opts }, isNotHost);
};
